import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Popconfirm, Row, Space, Table, Typography } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectUser } from '../../../auth/states/userSlice';
import { crud, perProps } from '../../../common/types/commonTypes';
import { Fixed2 } from '../../../common/utils/common.utils';
import { toasterNotification } from '../../../common/utils/ToasterNotification';
import usePagination from '../../../common/utils/usePagination';
import useUrlParams from '../../../common/utils/useUrlParams';
import BreadCrumb from '../../../components/common/breadCrumb/BreadCrumb';
import Reload from '../../../components/common/reload/Reload';
import { loadingIndicator } from '../../../components/common/spinner/LoadingIndicator';
import { parseDateRangeObject } from '../../../helpers/healper';
import {
  useDeleteAdvanceReturnMutation,
  useGetAllAdvanceReturnQuery,
} from '../api/endpoints/advanceEndpoints';
import { IGetAdvanceReturn } from '../types/vendor.interfaces';

const AdvanceReturn = ({ permission }: perProps) => {
  const { setUrlParam, setUrlParamsFromObject, getAllUrlParams } = useUrlParams();
  const { page, size, changePagination, pagination } = usePagination();
  const params_value = getAllUrlParams() as {
    search: string | null;
    from_date: string | null;
    to_date: string | null;
  };
  const [columnIndex, setColumnIndex] = useState<number | null>(null);
  // const { isLoading, data: advanceReturn, refetch } = useGetAllAdvanceReturnQuery();
  const {
    data,
    isFetching,
    refetch,
    isLoading: dataIsLoading,
  } = useGetAllAdvanceReturnQuery({
    ...getAllUrlParams(),
    page,
    size,
  });
  const user = useSelector(selectUser);

  const [deleteAdvanceReturn, { isError, isSuccess, isLoading: deleting }] =
    useDeleteAdvanceReturnMutation();

  const handleDelete = (id: number, index: number) => {
    const body = { id, deleted_by: user?.user_id as number };
    setColumnIndex(index);
    deleteAdvanceReturn(body);
  };

  // ================== notification =========================
  useEffect(() => {
    if (isSuccess) {
      setColumnIndex(null);
      toasterNotification('success', 'Advance return has been deleted!');
    }
    if (isError) {
      setColumnIndex(null);
      toasterNotification('error', 'Advance return can not deleted now!');
    }
  }, [isError, isSuccess]);

  const columns: ColumnsType<IGetAdvanceReturn> = [
    {
      title: 'SL.',
      key: 'key',
      render(value, record, index) {
        ++index;
        return index;
      },
    },
    {
      title: 'Return Date',
      dataIndex: 'return_date',
      key: 'return_date',
      align: 'left',
      render(value, record, index) {
        return value ? dayjs(value).format('DD-MM-YYYY') : '';
      },
    },
    {
      title: 'Vouchar No',
      dataIndex: 'advr_vouchar_no',
      key: 'advr_vouchar_no',
      align: 'left',
    },
    {
      title: 'Vendor Name',
      dataIndex: 'vendor_name',
      key: 'vendor_name',
      align: 'left',
    },

    {
      title: 'Advance Amount',
      dataIndex: 'advr_amount',
      key: 'advr_amount',
      align: 'right',
      render(value, record, index) {
        return Fixed2(value);
      },
    },
    {
      title: 'Return Note',
      dataIndex: 'advr_note',
      key: 'advr_note',
    },
    {
      title: 'Action',
      key: 'operation',

      render: (_, data, index) => (
        <Space size='small'>
          {permission?.[crud.update] && (
            <Link to={`/vendors/advance/edit/${data.advr_id}`}>
              <Button size='small' type='primary'>
                Edit
              </Button>
            </Link>
          )}

          {permission?.['read:any'] && (
            <Link to={`/vendors/advance/view/${data.advr_id}`}>
              <Button size='small' type='primary'>
                <Typography style={{ color: '#ffffff' }}>View</Typography>
              </Button>
            </Link>
          )}
          {permission?.[crud.delete] && (
            <Button
              size='small'
              type='primary'
              style={{ background: '#e90800', border: 'none' }}
              loading={columnIndex === index && true}
            >
              <Popconfirm
                onConfirm={() => handleDelete(data.advr_id, index)}
                title='Sure to delete?'
              >
                Delete
              </Popconfirm>
            </Button>
          )}
        </Space>
      ),
    },
  ];
  const dataWithKey = data?.data?.map((item, index) => ({
    key: String(index),
    ...item,
  }));
  const [form] = useForm();

  // const handelSearch = useCallback(
  //   debounce((e: string) => {
  //     setUrlParam('search', e);
  //   }, 500),
  //   []
  // );

  useEffect(() => {
    form.setFieldsValue({
      search: params_value.search,
      date_range: parseDateRangeObject({
        from_date: params_value.from_date,
        to_date: params_value.to_date,
      }),
    });
  }, [params_value]);
  return (
    <>
      <BreadCrumb arrOfOption={['List of Advance Return', 'Lists']} />

      <div style={{ marginBottom: '10px' }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 10 }} justify={'space-between'}>
          <Col span={12}>
            <Row gutter={10}>
              {permission?.['create:any'] && (
                <Col xs={24} sm={12} md={8} lg={8}>
                  <Link to={'/vendors/advance/add'}>
                    <Button type='primary' icon={<PlusOutlined />} style={{ width: '100%' }}>
                      Create
                    </Button>
                  </Link>
                </Col>
              )}

              <Col xs={24} sm={12} md={8} lg={8} style={{ display: 'flex' }}>
                <Col>
                  <Reload
                    refetch={() => {
                      refetch();
                    }}
                  />{' '}
                </Col>
              </Col>
            </Row>
          </Col>
          {/* <Col span={12}>
            <Form form={form}>
              <Row justify={'end'} gutter={[10, 10]}>
                <FormInput
                  name={'search'}
                  placeholder='Search here ...'
                  onChange={(e: string) => handelSearch(e.trim())}
                />
              </Row>
            </Form>
          </Col> */}
        </Row>
      </div>
      <div>
        <span style={{ float: 'left', marginBottom: '1rem' }}>
          You have total <strong>{data?.count ? data?.count : data?.data?.length}</strong> rows
        </span>
        <Table
          size='small'
          bordered
          rowKey={(e) => e.advr_id}
          columns={columns}
          loading={{
            spinning: dataIsLoading || isFetching,
            indicator: loadingIndicator,
          }}
          dataSource={dataWithKey}
          scroll={{ x: 'max-content' }}
          pagination={changePagination(data?.count)}
        />
      </div>
    </>
  );
};

export default AdvanceReturn;
